import { colors } from '@agria/theme/src/styles/tokens';

const theme = {
  backgroundSelected: 'brandOne100',
  disabledColor: 'brandOne50',
  disabledBackground: 'transparent',
  disabledBorder: 'brandOne50',
  focusBoxShadow: '0px 0px 0px 2px #FFF, 0px 0px 0px 4px #000',
  focusInvalidBoxShadow: `${colors.systemFocusInvalid};`,
  focusValidBoxShadow: `${colors.systemFocusValid};`,
  gap: 'medium',
  includeTick: false,
  includeUnderline: false,
  showSelectedIndicator: false,
  stacked: false,
} as const;

export default theme;
